import { render } from "./PriceExplanation.vue?vue&type=template&id=aa32659e"
import script from "./PriceExplanation.vue?vue&type=script&scoped=true&lang=js"
export * from "./PriceExplanation.vue?vue&type=script&scoped=true&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__